import ky, { type KyRequest } from 'ky';

import { getUserAccessToken } from '@/features/auth/services/oidc';

const setAccessTokenHook = async (request: KyRequest) => {
  const token = await getUserAccessToken();

  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }
};

export const api = ky.create({
  hooks: {
    beforeRequest: [setAccessTokenHook],
  },
  prefixUrl: import.meta.env.VITE_APP_API_URL,
  retry: 0,
});

export const fastApi = ky.create({
  hooks: {
    beforeRequest: [setAccessTokenHook],
  },
  retry: 0,
  prefixUrl: import.meta.env.VITE_APP_API_URL_FAST,
});
